import React from "react";
import "./startTieBreakFinalistWeekBtn.scss";

const StartTieBreakFinalistWeekBtn = ({
  onClick,
  style = {},
  className = "",
  disabled,
  text,
  icon: IconComponent,
  width,
}) => {
  const dynamicStyle = disabled
    ? { color: "black", cursor: "not-allowed" }
    : { color: "#b03a2e" };

  return (
    <button
      type="button"
      style={{ width, ...dynamicStyle, ...style }}
      className={`start-tiebreak-finalist-week-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled ? "true" : "false"}
    >
      {IconComponent && (
        <span className="start-tiebreak-finalist-week-btn-icon">
          <IconComponent fillColor={dynamicStyle.color} strokeColor={dynamicStyle.color} />
        </span>
      )}
      {text}
    </button>
  );
};

export default StartTieBreakFinalistWeekBtn;
